import { Box, Button, Typography } from "@mui/material";
import "./styles.css";
import "katex/dist/katex.min.css";
import Latex from "react-latex-next";
import NextAction from "../../utils/NextAction";

export default function Controls({ controls }) {
  const {
    xRotation,
    yRotation,
    zRotation,
    setXRotation,
    setYRotation,
    setZRotation,
    setStartAnimation,
  } = controls;

  return (
    <div className="controls">
      <div className="controlGroup">
        <Typography variant="h5" style={{ paddingBottom: 20 }}>
          Euler Angles
        </Typography>
        <Typography style={{ paddingBottom: 20, textAlign: "left" }}>
          This is the visualization of rotation matrix. The dark axes "O'-xyz'"
          are the rotated frame axes and the light one is the reference frame
          "O-xyz".
        </Typography>
        <Typography style={{ paddingBottom: 10, textAlign: "left" }}>
          Different from 9 variables in rotation matrix, there are only 3
          variable in Euler Angles. There are 27 possible types of Euler Angles
          and we show the most famous one : Roll-Pitch-Yaw(XYZ) here.
        </Typography>
        <Typography style={{ paddingBottom: 10, textAlign: "left" }}>
          Change the value of{" "}
          <Latex>
            $\psi,\ \vartheta,\ \varphi$ step by step and keep later variables
            0. Then, you will see the magic of Euler Angles. Always one axis is
            frozen.
          </Latex>
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <div className="control">
              <Latex>$\psi\ (degree)$</Latex>
              <input
                value={xRotation}
                onChange={(e) => setXRotation(parseInt(e.target.value))}
                step={1}
                type="number"
              />
            </div>
            <div className="control">
              <Latex>$\vartheta\ (degree)$</Latex>
              <input
                value={yRotation}
                onChange={(e) => setYRotation(parseInt(e.target.value))}
                step={1}
                type="number"
              />
            </div>
            <div className="control">
              <Latex>$\varphi\ (degree)$</Latex>
              <input
                value={zRotation}
                onChange={(e) => setZRotation(parseInt(e.target.value))}
                step={1}
                type="number"
              />
            </div>
          </Box>
          <Button
            variant="contained"
            onClick={() => {
              setStartAnimation(true);
            }}
          >
            Animation
          </Button>
        </Box>
      </div>
      <Latex>
        Rotation by an angle $\psi$ about X axis,
        {` $$R_x(\\psi) = \\left[ \\begin{array}
          {ccc} 1 & 0 & 0 \\\\ 0 & cos\\ \\psi & -sin\\ \\psi \\\\ 0 & sin\\ \\psi & cos\\ \\psi \\\\ \\end{array}
          \\right] $$`}
      </Latex>
      <Latex>
        Rotation by an angle $\vartheta$ about Y axis,
        {` $$R_y(\\vartheta) = \\left[ \\begin{array}
          {ccc} cos\\ \\vartheta & 0 & sin\\ \\vartheta \\\\ 0 & 1 & 0 \\\\ -sin\\ \\vartheta & 0 & cos\\ \\vartheta \\\\ \\end{array}
          \\right] $$`}
      </Latex>
      <Latex>
        Rotation by an angle $\varphi$ about Z axis,
        {` $$R_z(\\varphi) = \\left[ \\begin{array}
          {ccc} cos\\ \\varphi & -sin\\ \\varphi & 0 \\\\ sin\\ \\varphi & cos\\ \\varphi & 0 \\\\ 0 & 0 & 1 \\\\ \\end{array}
          \\right] $$`}
      </Latex>
      <Latex>
        $R = R_z(\varphi)R_y(\vartheta)R_x(\psi)$ is the rotation matrix of $\\$
        "O'-xyz" to reference frame "O-xyz"
      </Latex>
      <NextAction label={"Next: Quaternion"} to="/quaternion" />
    </div>
  );
}
